import { render, staticRenderFns } from "./veStuAssocRelationShow.vue?vue&type=template&id=1ec67294&scoped=true"
import script from "./veStuAssocRelationShow.vue?vue&type=script&lang=js"
export * from "./veStuAssocRelationShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec67294",
  null
  
)

export default component.exports